<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="contacts" :class="{ comingSoon: $isPlatOr(platformId, ['Sp']) }">
			<platform-tab @change="platformTabClick" :showAll="false" :platformId="platformId" />
			<template v-if="$isPlatOr(['Dy', 'Ks'])">
				<div class="mt-12 yx-form-wrap" v-show="showPlatformContent">
					<el-form inline :model="params" label-width="100px">
						<el-form-item v-if="$isDy()" label="活动信息">
							<el-input v-model="params.q" placeholder="请输入活动名称/ID" />
						</el-form-item>
						<template v-else>
							<el-form-item label="活动名称">
								<el-input v-model="params.activity_name" placeholder="请输入活动名称" />
							</el-form-item>
							<el-form-item label="活动ID">
								<el-input v-model="params.third_activity_id" placeholder="请输入活动ID" />
							</el-form-item>
						</template>
						<el-form-item label="活动状态">
							<el-select v-model="params.activity_status" clearable placeholder="请选择">
								<el-option v-for="item in activityStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<template v-if="$isKs()">
							<el-form-item label="活动类型">
								<el-select v-model="params.activity_type" clearable placeholder="请选择">
									<el-option v-for="(item, index) in activityTypeList" :key="index" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="创建时间">
								<el-date-picker
									v-model="createTime"
									type="daterange"
									@change="changTime($event, 'createTime')"
									value-format="timestamp"
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
								></el-date-picker>
							</el-form-item>
						</template>
						<el-form-item>
							<el-button type="primary" @click="getList(true, true)">查 询</el-button>
							<el-button @click="onClear">清 空</el-button>
						</el-form-item>
					</el-form>
				</div>
			</template>
			<div class="flex flex-just-center align-center" style="margin-top: 100px" :class="{ emptySPBox: $isPlatOr(platformId, ['Sp']) }" v-else>
				<emptyPage ref="emptyPage">
					<img slot="image" src="@/assets/public/dev-img.png" alt="" />
					<p class="fz-14 yx-color-text-regular" slot="desc">敬请期待</p>
				</emptyPage>
			</div>
		</Panel>
		<tempalte v-if="$isPlatOr(['Dy', 'Ks'])">
			<panel :contentPaddingTop="12" v-show="showPlatformContent">
				<div class="mt-24 flex flex-align-center flex-just-between">
					<el-button v-if="$auth.hasPermi('system:myActivities:create')" type="primary" @click="show(0, '新建招商活动')">新建招商活动</el-button>
					<div class="flex flex-align-center yx-color-text-regular">
						<div class="expire-checkbox" v-if="$isKs()">
							<el-checkbox v-model="params.seven_day_end" :true-label="1" :false-label="0" @change="getList(true)">7天内到期活动</el-checkbox>
						</div>
						<div class="form-item mr-12">
							<div class="form-label">团长</div>
							<div class="content">
								<commander-select
									:show-default="true"
									:platformId="platformId"
									v-model="authorityId"
									:show-all="true"
									:show-close="false"
									@change="getList(true)"
								></commander-select>
							</div>
						</div>
						<explain class="fz-12 mr-4" content="手动更新后有10min左右延迟，请主动刷新页面更新数据" />
						<div class="fz-13 mr-12">更新时间: {{ sync_time }}</div>
						<el-button icon="el-icon-refresh" @click="show(1, $isDy() ? '更新列表' : '同步活动列表')">
							{{ $isDy() ? '更新列表' : '同步活动列表' }}
						</el-button>
					</div>
				</div>
				<multi-table
					ref="multiTable"
					:key="platformId"
					:page="pageInfo"
					:columns="columns"
					@gePartnerList="pagerList"
					:list="list"
					:total="total"
					v-loading="loading"
				>
					<empty slot="empty" :isSearch="isSearch" @btnClick="synchroFun" btnText="同步团长活动" :btnShow="!isSearch" ref="empty"></empty>
				</multi-table>
			</panel>
		</tempalte>

		<new-activity-drawer ref="newActivity" @refresh="getList"></new-activity-drawer>
		<new-ks-activity-drawer ref="newKsActivity" @refresh="getList"></new-ks-activity-drawer>
		<synchro ref="synchro"></synchro>
		<tips ref="tips"></tips>
		<AuthAlertDialog ref="authAlertDialog"></AuthAlertDialog>
	</div>
</template>

<script>
import NewActivityDrawer from './components/newActivityDrawer';
import newKsActivityDrawer from './components/newKsActivityDrawer';
import Explain from '@/components/common/explain';
import { copy } from '@/utils/common';
import { activityStatusDyList, activityTypeList, activityStatusKsList } from '@/utils/dataMap';
import { getActivityList, getSyncTime, activitySync, closeKsActivity, deleteKsActivity } from '@/api/secondColonelManage';
import { mapGetters } from 'vuex';
import empty from '@/views/common/empty/index.vue';
import { checkAuthorize } from '@/api/shopManage';
import synchro from '@/views/common/dialog/synchro.vue';
import { PLATFORM_DY } from '@/utils/dataMap';
import { startOfDay, endOfDay } from 'date-fns';
import authMixin from '@/modules/auth/mixin';
import { getCommanderList } from '@/components/commanderSelect/index.js';
import commanderSelect from '@/components/commanderSelect/index.vue';
import getColumns from './columns';
import { platformMixin } from '@rd/rd-ui';
import emptyPage from '@/views/common/empty/index.vue';
export default {
	name: 'myActivitityList',
	components: {
		NewActivityDrawer,
		newKsActivityDrawer,
		Explain,
		empty,
		synchro,
		Tips: () => import('@/modules/auth/tips.vue'),
		AuthAlertDialog: () => import('@/modules/auth/alert.vue'),
		commanderSelect,
		emptyPage,
	},
	mixins: [authMixin, platformMixin],
	computed: {
		...mapGetters(['onlyKsVersion', 'defaultPlatform']),
		activityStatusList() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: activityStatusDyList,
				[dataMap.PLATFORM_KS.value]: activityStatusKsList,
			};
			return temPF[this.platformId] || '';
		},
		columns() {
			return getColumns(this);
		},
	},
	data() {
		return {
			activityTypeList,
			createTime: [],
			params: {
				activity_status: '0',
				q: '',
				activity_type: 0,
				apply_start_time: '',
				apply_end_time: '',
				third_activity_id: '',
				seven_day_end: 0,
			},
			platformId: '',
			sync_time: '',
			list: [],
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			isSearch: false,
			PLATFORM_DY: +PLATFORM_DY.value,
			loading: false,
			contactUserTypeArr: [
				{
					label: '全部',
					value: '0',
				},
				{
					label: '团长',
					value: '1',
				},
				{
					label: '团长 + 达人',
					value: '3',
				},
			],
			commanderList: [],
			commanderType: 0,
			authorityId: '',
		};
	},
	created() {
		this.platformId = +this.defaultPlatform;
		console.log(this.$isDy());
	},
	methods: {
		changTime(val, flag) {
			const setTime = ([startTime, endTime], start, end) => {
				this.params[start] = startTime && Math.trunc(startOfDay(startTime) / 1000);
				this.params[end] = endTime && Math.trunc(endOfDay(endTime) / 1000);
			};
			const obj = {
				createTime: time => setTime(time, 'apply_start_time', 'apply_end_time'),
			};
			obj[flag](val || ['', '']);
		},
		async getList(isInit, isSearch = false) {
			this.loading = true;
			this.isSearch = isSearch;
			isInit && (this.pageInfo.page_index = 1);
			this.getSyncTime();
			const { params, pageInfo, platformId: platform_id, authorityId: authority_id } = this;

			const { code, data: { list = [], page = {} } = {} } = await getActivityList({ ...params, ...pageInfo, platform_id, authority_id });
			this.loading = false;
			if (code !== 0) return;
			this.list = list.map(item => ({
				...item,
				operations: this.getButtons(item),
			}));
			this.total = page.item_total;
		},
		async getSyncTime() {
			const { platformId: platform_id } = this;
			const { code, data: { sync_time } = {} } = await getSyncTime({ type: 1, platform_id });
			if (code !== 0) return;
			this.sync_time = sync_time;
		},
		async show(type) {
			const { platformId } = this;
			this.commanderType = type;
			this.commanderList = await getCommanderList(true, platformId);
			if (!this.commanderList.length) {
				this.$message.error('暂无已授权团长，请联系管理员在“团队管理-团长授权”中进行团长授权');
				return;
			}
			this.onSuccess(this.authorityId);
		},
		async activitySync() {
			const { platformId: platform_id, authorityId: authority_id } = this;
			const { code } = await activitySync({ type: 1, platform_id, authority_id });
			if (code !== 0) return;
			this.$message.success('更新中，请稍等...');
			this.getSyncTime();
		},
		onClear() {
			this.params = {
				activity_status: '0',
				q: '',
				activity_type: 0,
				apply_start_time: '',
				apply_end_time: '',
				third_activity_id: '',
				seven_day_end: 0,
			};
			this.pageInfo.page_index = 1;
			this.createTime = [];
			this.getList(true);
		},
		pagerList(obj) {
			const { page_index, page_size } = obj;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getList();
		},
		onSuccess(val) {
			if (!val) {
				this.$message.error('请选择团长');
				return;
			}
			let refsMaps = new Map([
				[1, 'newActivity'],
				[2, 'newKsActivity'],
			]);
			// // 新建招商活动 回调
			if (+!this.commanderType) this.$refs[refsMaps.get(+this.platformId)].show(this.authorityId);
			// 抖音 更新列表 ｜ 快手同步活动列表
			if (+this.commanderType) this.activitySync();
		},
		copy(value) {
			copy(value);
			this.$message.success('复制成功');
		},
		goToDetail(id, third_activity_id) {
			if (!this.$auth.hasPermi('system:myActivities-detail:query')) {
				return;
			}
			const { platformId: platform_id } = this;
			this.$router.push({
				path: '/secondColonelManage/myActivities/detail',
				query: { id, third_activity_id, platform_id, authority_id: this.authorityId },
			});
		},
		handleClickTab(e) {
			const { PLATFORM_DY } = this;
			if (e != PLATFORM_DY) return;
			this.getList();
		},
		//同步
		// 保持不变
		async synchroFun() {
			const params = { platform_id: this.platformId };
			const data = await checkAuthorize(params);
			if (!data.bind_status) {
				this.checkAuthAdd(this.platformId);
			} else {
				this.show(1);
			}
		},
		platformTabClick(val) {
			this.platformId = val;
			this.authorityId = '';
			this.pageInfo.page_index = 1;
			this.total = 0;
			if (!this.showPlatformContent) return;
			this.list = [];
		},
		async deleteKsActivity(activity_id) {
			try {
				await this.$confirm('是否删除该活动，删除后无法恢复!', '确认删除活动？');
				const { code } = await deleteKsActivity({ activity_id, authority_id: this.authorityId });
				if (code !== 0) return;
				this.$message.success('删除活动成功');
				this.getList();
			} catch (error) {}
		},
		async closeKsActivity(activity_id) {
			try {
				await this.$confirm('该活动在报名中，若关闭会导致报名商品状态失效，也会影响团长信誉度，请确认是否关闭!', '确认关闭活动');
				const { code } = await closeKsActivity({ activity_id, authority_id: this.authorityId });
				if (code !== 0) return;
				this.$message.success('关闭活动成功');
				this.getList();
			} catch (error) {}
		},
		getButtons(row) {
			let arr = [];
			arr.push(
				{
					label: '详情',
					type: 'text',
					isShow: this.$auth.hasPermi('system:myActivities-detail:query'),
					click: row => this.goToDetail(row.activity_id, row.third_activity_id),
				},
				{
					label: '复制报名链接',
					type: 'text',
					isShow: +row.activity_status === 2 && this.$isDy(this.platformId) && this.$auth.hasPermi('system:myActivities:copyLink'),
					click: row => this.$copy('https://buyin.jinritemai.com/dashboard/institution/activity-apply?id=' + row.third_activity_id),
				},
				{
					label: '商家报名链接',
					type: 'text',
					isShow: ['2', '3'].includes(row.activity_status) && this.$auth.hasPermi('system:myActivities:copyLink') && this.$isKs(this.platformId),
					click: row => this.$copy('https://cps.kwaixiaodian.com/pc/cps/activity/ground/detail/' + row.third_activity_id),
				},
				{
					label: '团长报名链接',
					type: 'text',
					isShow:
						['2', '3'].includes(row.activity_status) &&
						this.$auth.hasPermi('system:myActivities:copyLink') &&
						this.$isKs(this.platformId) &&
						(row.activity_type == 1 || (row.activity_type == 2 && !['0', '1'].includes(row.preExclusiveActivitySignType))),
					click: row => this.$copy('https://cps.kwaixiaodian.com/pc/leader/activity/merchant_investment/detail/' + row.third_activity_id),
				},
				{
					label: '删除',
					type: 'text',
					isShow: +row.activity_status === 4 && this.$auth.hasPermi('system:myActivities:delete') && this.$isKs(this.platformId),
					click: row => this.deleteKsActivity(row.activity_id),
				},
				{
					label: '关闭活动',
					type: 'text',
					isShow: ['2', '3'].includes(row.activity_status) && this.$auth.hasPermi('system:myActivities:close') && this.$isKs(this.platformId),
					click: row => this.closeKsActivity(row.activity_id),
				},
			);
			return arr.filter(item => item.isShow);
		},
	},
};
</script>

<style lang="less" scoped>
.tag {
	height: 16px;
	line-height: 16px;
	padding: 0 4px;
	border-radius: 1px;
	background-color: #e9f1ff;
	color: @color-primary;
	font-size: 12px;
	margin-left: 4px;
}

.hit {
	display: flex;
	align-items: center;

	&::before {
		content: '';
		width: 4px;
		height: 4px;
		border-radius: 50%;
		margin-right: 4px;
	}

	&.start::before {
		background-color: #999999;
	}

	&.success::before {
		background-color: #0fb820;
	}

	&.end::before {
		background-color: red;
	}
}

.expire-checkbox {
	padding-right: 12px;
	margin-right: 12px;
	position: relative;

	::v-deep .el-checkbox__label {
		line-height: 14px;
	}

	&::after {
		content: '';
		width: 1px;
		height: 12px;
		background-color: #e3e3e3;
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
	}
}
.command_id {
	color: @color-gy8;
}
.form-item {
	display: flex;
	align-items: center;
	.form-label {
		font-weight: bold;
		margin-right: 12px;
		color: #666;
		font-size: 14px;
	}
}
</style>
